import { useContext } from 'react';

import { TodayContext } from './context';

export const useToday = () => {
  const { today } = useContext(TodayContext);

  return today;
};
